import { Injectable } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { CookiesComponent } from '../../../shared/modals/cookies/cookies.component';

@Injectable({
  providedIn: 'root'
})
export class CookiesServiceService {

  constructor(private matDialog: MatDialog) { }

  openCookiesTerms(){
    const policyCookies = localStorage.getItem('policyCookies');
    if( !policyCookies ){
      this.matDialog.open( CookiesComponent,
        {
          width: '100vw',
          maxWidth: '100vw',
          position: {
            bottom: '0',
          },
          panelClass: 'background-modal-cookies',
          disableClose: true,
        } );
     }
    }
}
